const categoryListingEvents = {
  FETCH_CATEGORY_DATA_PROGRESS: 'categoryList/fetch_data_progress',
  FETCH_CATEGORY_DATA_SUCCESS: 'categoryList/fetch_data_success',
  FETCH_CATEGORY_PAGE_DATA_SUCCESS: 'categoryList/page_data_success',
  FETCH_CATEGORY_PAGE_DATA_FAILED: 'categoryList/page_data_failed',
  FETCH_CATEGORY_DATA_NOT_FOUND: 'categoryList/fetch_data_not_found',
  FETCH_CATEGORY_DATA_FAILED: 'categoryList/fetch_data_failed',
  FILTER_CHANGE: 'categoryList/filter_change',
  CLEAR_PRODUCTS_LIST: 'categoryList/clear_products_list',
  SET_ACTIVE_FILTERS: 'categoryList/set_active_filters',
  SET_ACTIVE_SORT: 'categoryList/set_active_sort',
  SORT_CHANGE: 'category/sort_change',
  PAGE_CHANGE: 'category/page_change',
  FETCH_WIDGETS: 'category/widgets',
  INCREASE_PAGE: 'category/increase_page',
  RESET_WIDGETS: 'category/reset_widgets',
  CLICK_INTERACTION: 'category/clickInteraction',
  TOGGLE_CHANGE_FROM: 'toggleChangeFrom',
  CHANGE_FILTER_API_STATUS: 'category/filter_api_status',
  RESET_CLEAR_ALL: 'category/reset_clear_all',
  IS_FILTER_OPEN: 'category/is_filter_open',
  SET_BREADCRUMB: 'category/set_breacrumbs',
  FETCH_EDD_FILTER: 'category/fetch_edd_filter',
  SET_FETCH_FOOTER_DATA_ON_CLIENT: 'category/set_fetch_footer_data_on_client',
};

export default categoryListingEvents;
